export const initialSorting = {
  id: 'facility_name',
  desc: false,
};
